import {Injectable} from '@angular/core';
import {EntityEmail} from "../model/entity-email";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SharedPersistRequest} from "../model/requests/shared-persist-request";
import {HttpUtils} from "../shared/http.utils";
import {SharedFilters} from "../model/filters/shared-filters";
import {ResolvedResource} from "../model/resolved-resource";

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private readonly sharedURL: string;

  constructor(private http: HttpClient) {
    this.sharedURL = "/catalog/shared";
  }

  public getSharedResource(sharedResourceUuid: string): Observable<{ resolvedResource: ResolvedResource }> {
    let url = `${this.sharedURL}/${sharedResourceUuid}`;
    return this.http.get<{ resolvedResource: ResolvedResource }>(url);
  }

  public shareResource(sharedData: SharedPersistRequest) {
    let url = `${this.sharedURL}/share`;
    return this.http.post<any>(url, sharedData);
  }

  public stopSharing(sharedResourceUuid: string, entityEmails: EntityEmail[]): Observable<{ deletedResource: boolean }> {
    let url = `${this.sharedURL}/stop/${sharedResourceUuid}`;
    return this.http.post<{ deletedResource: boolean }>(url, entityEmails);
  }

  public getEmailsForSharedResources(sharedResourcesUuids: string[]): Observable<{ entityEmails: EntityEmail[] }> {
    let url = `${this.sharedURL}/entities`;
    return this.http.post<{ entityEmails: EntityEmail[] }>(url, sharedResourcesUuids);
  }

  public getEmailSuggestions(query: any): Observable<{ entityEmails: EntityEmail[] }> {
    let url = `${this.sharedURL}/search`;
    return this.http.post<{ entityEmails: EntityEmail[] }>(url, query);
  }

  public getSharedResourcesWithMe(offset?: number, limit?: number, filters?: SharedFilters): Observable<any> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new SharedFilters();
    return this.http.post<any>(this.sharedURL, body, options);
  }

  public getSharedResourcesByUser(offset?: number, limit?: number, filters?: SharedFilters): Observable<any> {
    let url = `${this.sharedURL}/own`;
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new SharedFilters();
    return this.http.post<any>(url, body, options);
  }
}
